import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/en/translation.json';
import translationES from './locales/es/translation.json';
import translationFRCA from './locales/fr-CA/translation.json';

const fallbackLng = ['en'];
const availableLanguages = ['en', 'es', 'fr-CA'];

const resources = {
  en: {
    translation: translationEN
  },
  es: {
    translation: translationES
  },
  'fr-CA': {
    translation: translationFRCA
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng,
    detection: {
      checkWhitelist: true,
      order: ['navigator']
    },
    debug: false,
    whitelist: availableLanguages,
    interpolation: {
      escapeValue: false // no need for react. it escapes by default
    }
  });

export default i18n;
